export class EntGrossProductCollectionFilter {
  page: number;
  size: number;
  deleted: boolean;
  year?: number;
  regionId?: number;
  productTypeIds: number[];
  farmCategoryIds: number[];
  unitMeasurementIds: number[];

  constructor(init?: Partial<EntGrossProductCollectionFilter>) {
	this.page = 1;
	this.size = 30;
	this.deleted = false;
	this.productTypeIds = [];
	this.farmCategoryIds = [];
	this.unitMeasurementIds = [];
	if (init) {
	  Object.assign(this, init)
	}
  }
}
